// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"813356c4","453":"7c8babfd","477":"7bb20dc4"}[chunkId] + ".chunk.js";
};